var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fbfbfb;}.b{fill:none;stroke:#582bb8;stroke-width:5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-746 -362)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M54,0A54,54,0,1,1,0,54,54,54,0,0,1,54,0Z",
    transform: "translate(746 362)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1187.471,724.426l13.889,13.71,23.85-23.821",
    transform: "translate(-405.972 -309.816)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCheckIcon);
export default __webpack_public_path__ + "static/media/white-check-icon.a6e6fe1bd0ecc38f0416ff7c9205965c.svg";
export { ForwardRef as ReactComponent };